export const BASE_URL = "https://unityaviation.in";
// export const BASE_URL = "https://orbitaviation.in";
// export const BASE_URL = "http://localhost:3001";

export const API_BASE_URL = `${BASE_URL}/api`;
export const IMAGE_BASE_URL = `${BASE_URL}/public/images/`;

export const ROLES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  SECTOR_OFFICER: 3,
  DRIVER: 4,
  SUPERVISOR: 5,
  FIELD_SUPERVISOR: 6,
  DIESEL_SUPERVISOR: 7,
  INVENTORY_SUPERVISOR: 8,
  SECURITY_GUARD: 11,
  HELPER: 9,
};

/**
 * Martial status
 */
export const MARTIAL_STATUS = {
  MARRIED: { id: 1, status: "Married", value: "married" },
  SINGLE: { id: 2, status: "Single", value: "single" },
  DIVORCED: { id: 3, status: "Divorced", value: "divorced" },
  WIDOWED: { id: 4, status: "Widowed", value: "widowed" },
  SEPARATED: { id: 4, status: "Separated", value: "separated" },
};

/**
 * Choice of Yes or No
 */
export const YES_NO = {
  YES: { id: 1, value: "YES", label: "Yes" },
  NO: { id: 2, value: "NO", label: "No" },
};

/**
 * Choice of Yes or No
 */
export const VACCINATION_STATUS = {
  NOT_VACCINATED: {
    id: 1,
    value: "NOT_VACCINATED",
    label: "Not Vaccinated Yet",
  },
  FIRST_DOSE: { id: 2, value: "FIRST_DOSE", label: "First Dose" },
  SECOND_DOSE: { id: 2, value: "SECOND_DOSE", label: "Second Dose" },
  BOOSTER_DOSE: { id: 2, value: "BOOSTER_DOSE", label: "Third/Booster Dose" },
};

export const DRIVER_TYPES = {
  STANDARD_DRIVER: 1,
  TRACTOR_DRIVER: 2,
  BAILER_DRIVER: 3,
  JCB_DRIVER: 4,
  RAKE_DRIVER: 5,
  CUTTER_DRIVER: 6,
  TROLLEY_DRIVER: 7,
};

export const DATE_FORMATS = {
  DATE_ONLY_FORMAT: "DD/MM/YYYY",
  DATE_TIME_FORMAT: "DD/MM/YYYY hh:mm:ss A",
};

// User KYC Types
export const KYC_TYPES = [
  {
    id: 1,
    value: "Passport",
  },
  {
    id: 2,
    value: "Adhaar Card",
  },
  {
    id: 3,
    value: "Voter Card",
  },
  {
    id: 4,
    value: "Ration Card",
  },
  {
    id: 5,
    value: "License",
  },
];

// User KYC Types
export const STATUS_TYPES = [
  {
    id: "1",
    value: "Active",
  },
  {
    id: "0",
    value: "Inactive",
  },
];

export const SUB_TEAM_TYPE = [
  {
    name: "Rake",
    value: "rake",
  },
  {
    name: "Bailer",
    value: "bailer",
  },
  {
    name: "Trolley",
    value: "trolley",
  },
];

export const EQUIPMENT_TYPE = {
  TROLLEY: 1,
  RAKE: 2,
  BAILER: 4,
  UPROOTER: 39,
};
